// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__14w-B","logo":"Toolbar_logo__1AsSQ","desktopOnly":"Toolbar_desktopOnly__1hekZ"};